import { Button } from '@codecorp/components'

export const CreatorButtons = () => (
    <>
        <Button
            type="reset"
            filled
            secondary
            className="mt-5 mr-5"
        >
            Clear
        </Button>
        <Button
            type="submit"
            filled
            className="hover:bg-blue-800"
        >
            Generate
        </Button>
    </>
)
